import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import {AuthenticationService} from "../../_services/authentication.service";
import {ToastrService} from "ngx-toastr";
import {Router} from "@angular/router";
import {ApiPathsService} from "../../../api-paths.service";
import {LoggedUser} from "../../Models/LoggedUser";

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {
  environment= environment
  Password: string;
  ConfermaPassword: string;
  constructor(
    private authSvc: AuthenticationService,
    private toastService: ToastrService,
    private router: Router,
    private apiPaths: ApiPathsService
  ) { }

  ngOnInit(): void {

  }

  Change() {
    if(!(this.Password?.length > 0)) {
      this.toastService.info("Inserire il campo Password");
      return;
    }
    if(!(this.ConfermaPassword?.length > 0)) {
      this.toastService.info("Inserire il campo Conferma Password");
      return;
    }
    if(this.ConfermaPassword != this.Password){
      this.toastService.info("Le password non corrispondono");
      return;
    }
    var user: LoggedUser = this.authSvc.currentUserValue;
    user.password = this.Password;
    user.ConfermaPassword = this.ConfermaPassword;
    user.cambio_pwd = false;
    this.apiPaths.ClassicPost('/anagrafica/profilo/persona/update', user).subscribe(data=>{
      user.password = null;
      user.ConfermaPassword = null;
      localStorage.setItem('currentUser', JSON.stringify(user));
      this.toastService.success("Password Modificata Correttamente")
      this.router.navigate(["/Login"]);
    })


  }

  Annulla() {
    this.authSvc.logout();
  }
}
